import * as classNames from 'classnames';
import * as React from 'react';
import { IValidatorPackage } from '../../Validators';

import './CheckboxField.css';

interface ICheckboxFieldProps {
    label: string;
    isLabelLink?: boolean;
    checkLabel: string;
    required?: boolean;
    checked: boolean;
    handleChange: (checked: boolean) => void;
    deferErrors: boolean;
    validators: IValidatorPackage[];
}

interface ICheckboxFieldState {
    touched: boolean;
}

class CheckboxField extends React.PureComponent<ICheckboxFieldProps, ICheckboxFieldState> {
    constructor(props: ICheckboxFieldProps) {
        super(props);

        this.state = {
            touched: false
        };
    }

    onClickCheck = () => {
        this.props.handleChange(!this.props.checked);
    }

    render() {
        let valid = true;
        let errorMsg = '';
        this.props.validators.forEach((validatorPackage) => {
            if (!valid) {
                return;
            }
            if (validatorPackage.validator(this.props.checked.toString()) === false) {
                valid = false;
                errorMsg = validatorPackage.errorMessage;
            }
        });
        const showError = !valid && (this.props.deferErrors === false);
        const CheckboxFieldClasses = classNames('CheckboxField', {
            'CheckboxField--error': showError
        });

        const boxClasses = classNames('CheckboxField-box', {
            'CheckboxField-box--selected': this.props.checked
        });

        return (
            <div className={CheckboxFieldClasses}>
                <div className={'CheckboxField-label'}>
                    {this.props.isLabelLink
                        ? <a href={this.props.label} target={'_blank'} rel={'noopener noreferrer'}>{this.props.label}</a>
                        : this.props.label
                    }
                    {/* {this.props.required && (
                        <span className={'CheckboxField-required'}>{' *'}</span>
                    )} */
                    // Disabled because showing this inside the button looks much better
                    // Probably a terrible misuse, I'm sorry :(
                    }
                </div>
                    <div className={'CheckboxField-option'}>
                        <div className={boxClasses} onClick={this.onClickCheck}>
                            <div className={'CheckboxField-box-inner'}>{}</div>
                        </div>
                        <div className={'CheckboxField-checkLabel'}>
                            {this.props.checkLabel}
                        </div>
                    </div>
                {showError && (
                    <div className={'CheckboxField-error'}>{errorMsg}</div>
                )}
            </div>
        );
    }
}

export default CheckboxField;
